// M9-S4 — Emotional arc celebrate (§3.4.1).
// 3 milestone (ilk proje / ilk approve / ilk docx) için tek-seferlik confetti burst.
// `prefers-reduced-motion: reduce` kullanıcıları skip — sessiz ama yine de tick kaydedilir.

import confetti from "canvas-confetti";

const STORAGE_PREFIX = "mahir.celebrate.";

function prefersReducedMotion(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

function resolveToken(name: string, fallback: string): string {
  if (typeof document === "undefined") return fallback;
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

function burst(): void {
  // 2-3 saniyelik nispeten kontrollü burst. Abartmaz (master plan §3.4.1 "saygın sessizlik" sınırında).
  // Renkler paletten çözülür — müşteri palet revizyonunda confetti de takip eder.
  const end = Date.now() + 1200;
  const colors = [
    resolveToken("--color-dark", "#0F2A3D"),
    resolveToken("--color-success", "#14673E"),
    resolveToken("--color-warning", "#A05C00"),
    resolveToken("--color-accent", "#C9543A"),
  ];
  const frame = (): void => {
    void confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0, y: 0.7 },
      colors,
    });
    void confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1, y: 0.7 },
      colors,
    });
    if (Date.now() < end) requestAnimationFrame(frame);
  };
  frame();
}

/**
 * `key` localStorage'da true ise no-op. Değilse confetti çalar + flag'i set eder.
 * `prefers-reduced-motion` kullanıcıları için de flag set edilir (ikinci kez tetiklenmesin).
 */
export function celebrateOnce(key: string): void {
  if (typeof window === "undefined") return;
  const storageKey = `${STORAGE_PREFIX}${key}`;
  if (window.localStorage.getItem(storageKey)) return;
  window.localStorage.setItem(storageKey, "1");
  if (prefersReducedMotion()) return;
  try {
    burst();
  } catch {
    // canvas destekleme eksikse sessizce geç
  }
}

/**
 * Zorla tetikle (test/dogfood). Flag kullanmaz.
 */
export function celebrateNow(): void {
  if (typeof window === "undefined") return;
  if (prefersReducedMotion()) return;
  try {
    burst();
  } catch {
    // no-op
  }
}
